import SignatureModalContent from './SignatureModalContent';

export default SignatureModalContent;
